'use client';
var ModalSize;
(function (ModalSize) {
    ModalSize["SMALL"] = "sm";
    ModalSize["MEDIUM"] = "md";
    ModalSize["LARGE"] = "lg";
})(ModalSize || (ModalSize = {}));
var ModalHeight;
(function (ModalHeight) {
    ModalHeight["SMALL"] = "sm";
    ModalHeight["MEDIUM"] = "md";
    ModalHeight["LARGE"] = "lg";
    ModalHeight["AUTO"] = "auto";
})(ModalHeight || (ModalHeight = {}));
const ModalSizeToClass = {
    [ModalSize.SMALL]: 'sm:max-w-lg',
    [ModalSize.MEDIUM]: 'sm:max-w-2xl',
    [ModalSize.LARGE]: 'sm:max-w-6xl',
};
const ModalHeightToClass = {
    [ModalHeight.SMALL]: 'sm:h-[650px]',
    [ModalHeight.MEDIUM]: 'sm:h-[800px]',
    [ModalHeight.LARGE]: 'sm:h-[90%]',
    [ModalHeight.AUTO]: '',
};

export { ModalHeight, ModalHeightToClass, ModalSize, ModalSizeToClass };
//# sourceMappingURL=constants.js.map
